import {
  hasMatchingCategories,
  hasMatchingCountry,
  hasMatchingGender,
  hasMatchingProductTag,
} from './matcher-utils';

export const CAMPAIGN_FILTER_TYPES = [
  { name: 'countries', matcher: hasMatchingCountry },
  { name: 'genders', matcher: hasMatchingGender },
  { name: 'categories', matcher: hasMatchingCategories },
  { name: 'productTags', matcher: hasMatchingProductTag },
];

export const isLineFilteredOut = (line, selectedFilters) =>
  CAMPAIGN_FILTER_TYPES.some(
    ({ name, matcher }) => !matcher(line, selectedFilters[name]),
  );

export function filtersApplied(campaignLineFilters) {
  return Object.values(campaignLineFilters).some(filter => filter.length);
}

export function getAvailableFilterValues(campaignLinesById) {
  const countries = new Set();
  const genders = new Set();
  const categories = new Set();
  const productTags = new Set();

  Object.values(campaignLinesById).forEach(line => {
    if (line.country) countries.add(line.country.name);
    if (line.gender) genders.add(line.gender);
    if (line.productTag) productTags.add(line.productTag);
    (line.categories || []).forEach(category => categories.add(category));
  });

  return {
    countries: Array.from(countries),
    genders: Array.from(genders),
    categories: Array.from(categories),
    productTags: Array.from(productTags),
  };
}

export function getCategoryOptions(availableCategories, allCategories) {
  return allCategories
    .map(group => ({
      ...group,
      options: group.options.filter(({ value }) =>
        availableCategories.includes(value),
      ),
    }))
    .filter(group => group.options.length);
}

export const removeDeprecatedTextBundles = textBundles => {
  const currentDate = new Date();
  const filteredTextBundles = textBundles.filter(bundle => {
    return !bundle?.deprecated || new Date(bundle?.deprecated) > currentDate;
  });
  return filteredTextBundles;
};
